import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;

  .recharts-layer.recharts-bar-rectangle .recharts-rectangle:hover {
    fill: ${(props): string => props.theme.palette.secondary.contrast};
  }
`;
